import {defineMessages} from "react-intl";

export default defineMessages({
    accessList: {id: 'accesses.accessList', defaultMessage: 'ACCESS LIST', description: 'Accesses: ACCESS LIST'},
    globalAccessList: {id: 'accesses.globalAccessList', defaultMessage: 'GLOBAL ACCESS LIST', description: 'Accesses: GLOBAL ACCESS LIST'}
})